<template>
  <div class="blockTime">
    <p class="day">{{ day }}</p>
    <div class="year-month">
      {{ year }}.{{ month }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'blockTime',
  props: {
    day: String,
    month: String,
    year: String
  }
}
</script>

<style scoped>
.blockTime {
  display: flex;
  flex-direction: column;
  width: 75px;
  color: #000;
}
  .day {
    text-align: center;
    font-size: 36px;
    font-weight: bold;
  }
  .year-month {
    margin-top: 2px;
    font-size: 20px;
    text-align: center;
  }
</style>
